export default __webpack_public_path__ + "static/media/Emojis19.aea8d79a.png";